/**
 * @param {Object} params
 * @param {Array<{
 *   permissions: string[],
 *   order: number,
 *   orderNoPermission: number,
 *   [key: string]: any
 * }>} params.notificationsTabs
 * @param {(permissions: string[]) => boolean} params.hasPermission
 * @returns {Array}
 */
const sortNotificationsTabs = ({ notificationsTabs, hasPermission }) => {
  return [...notificationsTabs].sort((a, b) => {
    const aOrder = hasPermission(a.permissions) ? a.order : a.orderNoPermission;
    const bOrder = hasPermission(b.permissions) ? b.order : b.orderNoPermission;

    return aOrder - bOrder;
  });
};

export default sortNotificationsTabs;
